var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29,10.65A18.34,18.34,0,0,0,13.09,38.13l-2.37,7.34a1.46,1.46,0,0,0,.35,1.46,1.47,1.47,0,0,0,1.46.35l7.34-2.37A18.35,18.35,0,1,0,29,10.65Zm0,33.83a15.36,15.36,0,0,1-8.19-2.35,1.45,1.45,0,0,0-1.2-.15l-5.3,1.71L16,38.39a1.49,1.49,0,0,0-.15-1.2A15.48,15.48,0,1,1,29,44.48ZM30.79,29A1.79,1.79,0,1,1,29,27.21,1.79,1.79,0,0,1,30.79,29ZM38,29a1.8,1.8,0,1,1-1.79-1.79A1.79,1.79,0,0,1,38,29ZM23.63,29a1.8,1.8,0,1,1-1.8-1.79A1.8,1.8,0,0,1,23.63,29Z",
    style: {
      fill: "#30373d"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.05820ee4a1f34401129880d3adc51560.svg";
export { ForwardRef as ReactComponent };